<template>
    <div class="c-SelectTerm">
        <h3>Wybierz termin</h3>
        <label>
            <input type="radio" v-model="lead.term_from" value="możliwie najszybciej"> Możliwie najszybciej
        </label>
        <br>
        <label>
            <input type="radio" v-model="lead.term_from" value="wizty od"> Wizyty od: <strong>{{ lead.date }}</strong>
        </label>
        <DatePicker v-if="lead.term_from == 'wizty od'" v-model="lead.date" valueType="format" :lang="getDatepickerConfig" :disabled-date="getDatepickerConfig.range" :open="true" :append-to-body="false" :popup-style="{top:0,position:'relative',left:0}"></DatePicker>
        <br>
        <label>
            <input type="radio" v-model="lead.term_from" value="sobota"> Sobota
        </label>
     
        <p>
            <strong>Wybierz preferowaną<br>porę dnia:</strong>
        </p>
        <label v-for="time in getTimeOfday" class="pb--1">
            <input type="radio" name="term" v-model="lead.time_of_day" :value="time.name"> {{ time.name }}
            <br>
        </label>
        <Row>
            <span class="mt--1 mr--2">
                <img src="@/assets/images/info.png" alt="Zarezerwuj wizytę">
            </span>
            <p>
                <small>Wybrany termin jest orientacyjny i zostanie potwierdzony drogą telefoniczną przez pracownika serwisu najszybciej, jak tylko możliwe</small>
            </p>
        </Row>
    </div>
</template>
<script>

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/scss/icon.scss';
    import 'vue2-datepicker/scss/btn.scss';
    import lead from '../mixins/lead.js'

    import { mapGetters } from 'vuex'
 
    export default {
        data(){
            return {
                date:null
            }
        },
        mixins:[lead],
        computed: {
            ...mapGetters([
                'getDatepickerConfig',
                'getTimeOfday'
            ])
        },
        components:{
            DatePicker
        }
    }
</script>
<style lang="scss">
    @import '@/_variables.scss';
    .c-SelectTerm{
        width: 100%;
        margin: 0 1rem;
    }
    .mx{
        &-datepicker{
            margin: 0 auto;
            padding: 1rem 2rem;
            border-radius: 1rem;
            box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.16);
            margin-top:1rem;
        }
        &-input-wrapper{
           display: none;
        }
        &-input{
            border: 0;
            outline: none;
            font-size: 1rem;
            font-family: 'AudiType';
            text-align: center;
            width: 120px;
        }
        &-calendar-content{
            width: 100%;
        }
        &-table{
            width: 100%;
            th,td{
                text-align: center;
                padding: .5rem;
            }
            td{
                cursor: pointer;
                border: 1px solid #fff;
                color: #000;
                border-radius:.25rem;
                &:hover{
                    border: 1px dashed $red;
                }
                &.disabled{
                    color: $gray;
                    cursor: not-allowed;
                }
                &.active{
                    background: $red;
                    color: #fff;
                }
            }
            thead{
                th{
                    font-weight: bold;
                    color: $gray;
                }
            }
        }
        &-btn-text{
            border: 0;
            background: transparent;
            font-size:1rem;
            font-family: 'AudiType';
            font-weight: 100;
            font-weight: bold;
            // padding: .5rem 1rem;
            // margin-right: 1rem;
            font-size: 1.5rem;
            color:#000
        }
        &-btn-current-month,&-btn-current-year{
            &:hover{
                background: transparent;
            }
        }
        &-calendar-header{
            margin-top:1rem;
            max-width: 280px;
            margin: 0 auto;
            &-label{
                text-align: center;
                margin: 0 auto;
                display: block;
            }
        }
        &-btn-icon-left,
        &-btn-icon-double-left{float:left;}
        &-btn-icon-right,
        &-btn-icon-double-right{float:right;}
    }
</style>